<template>
    <div>
        <ListKomisix v-if="islistkomisi" v-on:backtolistpenggajian="back" v-on:gotocreatepenggajian="showcreatekomisi"
        v-on:showeditkomisix="showeditkomisi"/>
        <CreateKomisi  v-if="iscreatekomisip" v-on:backtolistkomisi="showlistkomisi"/>
        <EditKomisix v-if="iseditkomisix" v-bind:dataidkomisix="dataidkomisx" v-on:backtolist="showlistkomisix"/>
    </div>
</template>

<script>
    import ListKomisix from "./ListKomisix";
    import CreateKomisi from "./CreateKomisi";
    import EditKomisix from "./EditKomisix";
    export default {
        name: "AddKomisiP",
        components:{
            EditKomisix,
            ListKomisix,CreateKomisi
        },
        data(){
            return{
                islistkomisi:false,
                iscreatekomisip:false,
                iseditkomisix:false,

                dataidkomisx:{
                    idkomisix:'',
                }
            }
        },
        mounted() {
            this.showlistkomisi()
        },
        methods:{
            showlistkomisi(){
                this.islistkomisi=true;
                this.iscreatekomisip=false;
                this.iseditkomisix=false;
            },

            showlistkomisix(){
                this.islistkomisi=true;
                this.iscreatekomisip=false;
                this.iseditkomisix=false;
                $('#listkomisix').show();
            },

            showcreatekomisi(){
                this.islistkomisi=false;
                this.iscreatekomisip=true;
                this.iseditkomisix=false;
            },

            showeditkomisi(idkomisix){
                $('#listkomisix').hide();
                this.iseditkomisix=true;
                this.islistkomisi=false;
                this.iscreatekomisip=false;
                this.dataidkomisx.idkomisix=idkomisix;
            },

            back(){
                this.$emit('backtolistpenggajian');
            }
        }

    }
</script>

<style scoped>

</style>